<div class="side-navigation-container secondary-menu">
  @if (showRecentContent) {
    <div class="item">
      <a
        id="recentTabLink"
        href="javascript:void(0);"
        tabindex="0"
        [ngClass]="{ active: currentTab === navigationTabs.recent }"
        (click)="selectRecent()"
      >
        <svg-icon src="/assets/icons/time.svg" alt="Recent" i18n-alt />
        <span class="name" i18n>Recent</span>
      </a>
    </div>
  }
  <div class="item">
    <a
      id="ridesTabLink"
      href="javascript:void(0);"
      tabindex="0"
      [ngClass]="{ active: currentTab === navigationTabs.trackedRides }"
      (click)="selectTrackedRides()"
    >
      <svg-icon src="/assets/icons/rides.svg" alt="Rides" i18n-alt />
      <span class="name" i18n>Tracked Rides</span>
      @if (selectedItems) {
        <div class="count-container">
          @if (selectedItems.trackedRides.length) {
            {{ selectedItems.trackedRides.length }}
          }
        </div>
      }
    </a>
  </div>
  <div class="item">
    <a
      id="placesTabLink"
      href="javascript:void(0);"
      tabindex="0"
      [ngClass]="{ active: currentTab === navigationTabs.waypoints }"
      (click)="selectWaypoints()"
    >
      <svg-icon src="/assets/icons/waypoint.svg" alt="Places" i18n-alt />
      <span class="name" i18n>Places</span>
      @if (selectedItems) {
        <div class="count-container">
          @if (selectedItems.waypoints.length) {
            {{ selectedItems.waypoints.length }}
          }
        </div>
      }
    </a>
  </div>
  <div class="item">
    <a
      id="routesTabLink"
      href="javascript:void(0);"
      tabindex="0"
      [ngClass]="{ active: currentTab === navigationTabs.plannedRides }"
      (click)="selectPlannedRides()"
    >
      <svg-icon src="/assets/icons/routes.svg" alt="Routes" i18n-alt />
      <span class="name" i18n>Routes</span>
      @if (selectedItems) {
        <div class="count-container">
          @if (selectedItems.plannedRides.length) {
            {{ selectedItems.plannedRides.length }}
          }
        </div>
      }
    </a>
  </div>
  @if (showGeofences) {
    <div class="item">
      <a
        id="areasTabLink"
        href="javascript:void(0);"
        tabindex="0"
        [ngClass]="{ active: currentTab === navigationTabs.geofences }"
        (click)="selectGeofences()"
      >
        <svg-icon src="/assets/icons/area.svg" alt="Areas" i18n-alt />
        <span class="name" i18n>Areas</span>
        @if (selectedItems) {
          <div class="count-container">
            @if (selectedItems.geofences.length) {
              {{ selectedItems.geofences.length }}
            }
          </div>
        }
      </a>
    </div>
  }
  <div class="item">
    <a
      id="collectionsTabLink"
      href="javascript:void(0);"
      tabindex="0"
      [ngClass]="{ active: currentTab === navigationTabs.collections }"
      (click)="selectCollections()"
    >
      <svg-icon src="/assets/icons/collection.svg" alt="Collections" i18n-alt />
      <span class="name" i18n>Collections</span>
      @if (selectedItems) {
        <div class="count-container">
          @if (selectedItems.collections.length) {
            {{ selectedItems.collections.length }}
          }
        </div>
      }
    </a>
  </div>
</div>
